import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router";
import { ChevronLeftOutlined as ArrowLeftIcon } from "@mui/icons-material";
import Button from "@accredo/fe-shared/theme/components/Button.jsx";
import PropTypes from "prop-types";
import ClaimStatusBadge from "../ClaimStatusBadge.jsx";

export default function ClaimPreCheckModal({ open, onClose, claim }) {
  const navigate = useNavigate();
  const siblings = claim?.permissions?.split_siblings ?? [];
  const split_claims = siblings.length > 0 ? [claim, ...siblings] : [];

  const handleGoToOverview = () => {
    // First close the dialog (which also clears URL params via parent),
    // then navigate to the Schaden overview.
    onClose();
    navigate("/schaeden");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Schaden gemeldet</DialogTitle>
      <DialogContent dividers>
        {split_claims.length > 0 ? (
          <>
            <Typography variant="paragraph">
              Vielen Dank für die Meldung des Schadens. Er wurde je Sparte in
              eigene Schäden aufgeteilt:
            </Typography>
            <Box component="ul" sx={{ pl: 2, my: 1 }}>
              {split_claims.map((split_claim) => (
                <Box
                  component="li"
                  key={split_claim.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 0.5,
                  }}
                >
                  <Typography variant="body1">
                    {split_claim.schaden_nummer_accredo} · {split_claim.sparte}
                  </Typography>
                  <ClaimStatusBadge
                    status={split_claim.status?.value}
                    label={split_claim.status?.label}
                  />
                </Box>
              ))}
            </Box>
            <Typography variant="paragraph">
              Die gemeldeten Schäden befinden sich nun in Prüfung, die übrigen
              bleiben gespeichert und können später gemeldet werden.
            </Typography>
          </>
        ) : (
          <Typography variant="paragraph">
            Vielen Dank für die Meldung des Schadens. Dieser befindet sich nun
            in Prüfung durch accredo.
          </Typography>
        )}
        <Typography variant="body1">
          Angaben zu den Schadenkosten können nachträglich über den Reiter
          Kostenpositionen auf der Schadenseite getätigt werden.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button
          variant="neutral"
          startIcon={<ArrowLeftIcon />}
          onClick={handleGoToOverview}
        >
          Übersicht
        </Button>
        <Button onClick={onClose} variant="primary">
          Zur Schadenseite
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ClaimPreCheckModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  claim: PropTypes.object,
};
